import { Action } from '@ngrx/store';
import {DeviceMgtList} from '../device-mgt.model';

export enum DeviceMgtListActionTypes {
  GetDeviceMgtLists = '[DeviceMgtList] Get DeviceMgtLists',
  LoadDeviceMgtLists = '[DeviceMgtList] Load DeviceMgtLists',
  GetDeviceMgtListsFail = '[DeviceMgtList] Get DeviceMgtLists Fail'
}

export class LoadDeviceMgtLists implements Action {
  readonly type = DeviceMgtListActionTypes.LoadDeviceMgtLists;
  constructor(public payload: DeviceMgtList[]) {}
}

export class GetDeviceMgtLists implements Action {
  readonly type = DeviceMgtListActionTypes.GetDeviceMgtLists;

  constructor(public payload: any = null) {}
}

export class GetDeviceMgtListsFail implements Action {
  readonly type = DeviceMgtListActionTypes.GetDeviceMgtListsFail;
}

export type DeviceMgtListActions = LoadDeviceMgtLists
  | GetDeviceMgtLists
  | GetDeviceMgtListsFail;
